import React from 'react';

import { Emoji, EmojiCode } from '@/components/shared/Emoji';

import styles from './ReactionPanel.module.scss';

export type ReactionPanelProps = {
	selectedEmoji?: string;
	onClick: (code: string) => void;
	className?: string;
};

export const ReactionPanel = ({
	selectedEmoji,
	onClick,
	className,
}: ReactionPanelProps) => {
	const classes = [styles['reactions'], className].filter(Boolean).join(' ');

	return (
		<div className={classes}>
			{Object.values(EmojiCode).map((code) => {
				const selected = code === selectedEmoji;

				const classes = [
					styles['reactions__reaction-container'],
					selected
						? styles['reactions__reaction-container--selected']
						: '',
				].join(' ');

				return (
					<div
						key={`emoji-${code}`}
						className={classes}
						onClick={() => onClick(code)}
					>
						<div className={styles['reactions__reaction']}>
							<Emoji code={code} animated />
						</div>
					</div>
				);
			})}
		</div>
	);
};
